var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("平台建设")]),
              _c("el-breadcrumb-item", [_vm._v("配置管理")]),
              _c("el-breadcrumb-item", [_vm._v("自动派单设置")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "100px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "区域园区" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                on: { focus: _vm.handleSelectFocus },
                                model: {
                                  value: _vm.searchForm.idcpName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "idcpName", $$v)
                                  },
                                  expression: "searchForm.idcpName"
                                }
                              },
                              _vm._l(_vm.campusOptions, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: Object.values(item)[0],
                                    value: Object.values(item)[0]
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "账号类型" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.accountType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "accountType", $$v)
                                  },
                                  expression: "searchForm.accountType"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "值班账号",
                                    value: "值班账号"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "专项人员",
                                    value: "专项人员"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "资产专项",
                                    value: "资产专项"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "被派单人" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入名称" },
                              model: {
                                value: _vm.searchForm.return_name,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "return_name", $$v)
                                },
                                expression: "searchForm.return_name"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "被派电话" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入电话" },
                              model: {
                                value: _vm.searchForm.return_tel,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "return_tel", $$v)
                                },
                                expression: "searchForm.return_tel"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ]),
                          _c(
                            "el-button",
                            { on: { click: _vm.debouncedExport } },
                            [_vm._v(_vm._s(_vm.exportButtonText))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "title-en" }, [_vm._v("自动派单设置")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c("div", { staticClass: "button-container" }, [
              _c(
                "div",
                { staticClass: "button-left" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleAdd }
                    },
                    [_vm._v("新增")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "button-right" },
                [
                  _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                    _vm._v("表头设置")
                  ])
                ],
                1
              )
            ]),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.faults, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              _vm._l(_vm.visibleColumns, function(column, index) {
                return _c("el-table-column", {
                  key: index,
                  attrs: {
                    prop: column.prop,
                    label: column.label,
                    width: column.width,
                    align: column.align,
                    fixed: column.fixed
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            column.prop === "return_name"
                              ? _c("span", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "editable-cell",
                                      on: {
                                        click: function($event) {
                                          return _vm.startEdit(
                                            scope.row,
                                            "return_name"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm.editingCell.rowId !== scope.row.id ||
                                      _vm.editingCell.field !== "return_name"
                                        ? _c(
                                            "span",
                                            { staticClass: "editable-text" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    scope.row.return_name || "-"
                                                  ) +
                                                  "\n                  "
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-edit editable-icon"
                                              })
                                            ]
                                          )
                                        : _c("el-input", {
                                            attrs: {
                                              size: "mini",
                                              autofocus: "",
                                              "data-row-id": scope.row.id,
                                              "data-field": "return_name"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.finishEdit(
                                                  scope.row,
                                                  "return_name",
                                                  scope.row.return_name
                                                )
                                              }
                                            },
                                            nativeOn: {
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.finishEdit(
                                                  scope.row,
                                                  "return_name",
                                                  scope.row.return_name
                                                )
                                              }
                                            },
                                            model: {
                                              value: scope.row.return_name,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "return_name",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.return_name"
                                            }
                                          })
                                    ],
                                    1
                                  )
                                ])
                              : column.prop === "return_tel"
                              ? _c("span", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "editable-cell",
                                      on: {
                                        click: function($event) {
                                          return _vm.startEdit(
                                            scope.row,
                                            "return_tel"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm.editingCell.rowId !== scope.row.id ||
                                      _vm.editingCell.field !== "return_tel"
                                        ? _c(
                                            "span",
                                            { staticClass: "editable-text" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    scope.row.return_tel || "-"
                                                  ) +
                                                  "\n                  "
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-edit editable-icon"
                                              })
                                            ]
                                          )
                                        : _c("el-input", {
                                            attrs: {
                                              size: "mini",
                                              autofocus: "",
                                              "data-row-id": scope.row.id,
                                              "data-field": "return_tel"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.finishEdit(
                                                  scope.row,
                                                  "return_tel",
                                                  scope.row.return_tel
                                                )
                                              }
                                            },
                                            nativeOn: {
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.finishEdit(
                                                  scope.row,
                                                  "return_tel",
                                                  scope.row.return_tel
                                                )
                                              }
                                            },
                                            model: {
                                              value: scope.row.return_tel,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "return_tel",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.return_tel"
                                            }
                                          })
                                    ],
                                    1
                                  )
                                ])
                              : column.prop === "operation"
                              ? _c(
                                  "span",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleViewDetail(
                                              scope.row
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("查看详情")]
                                    )
                                  ],
                                  1
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row[column.prop] || "-"))
                                ])
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              }),
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  "append-to-body": true,
                  width: "400px",
                  "close-on-click-modal": false,
                  "custom-class": "columns-dialog",
                  "modal-append-to-body": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "新增自动派单账号",
                  visible: _vm.addDialogVisible,
                  width: "500px",
                  "append-to-body": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.addDialogVisible = $event
                  }
                }
              },
              [
                _c(
                  "el-form",
                  { attrs: { model: _vm.addForm, "label-width": "200px" } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "园区一级机房名称",
                          prop: "return_name"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入带后缀名称园区idcpName"
                          },
                          model: {
                            value: _vm.addForm.idcpName,
                            callback: function($$v) {
                              _vm.$set(_vm.addForm, "idcpName", $$v)
                            },
                            expression: "addForm.idcpName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "账号类型", prop: "accountType" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择账号类型" },
                            model: {
                              value: _vm.addForm.accountType,
                              callback: function($$v) {
                                _vm.$set(_vm.addForm, "accountType", $$v)
                              },
                              expression: "addForm.accountType"
                            }
                          },
                          _vm._l(_vm.accountTypeOptions, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "被派单人", prop: "return_name" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入被派单人姓名" },
                          model: {
                            value: _vm.addForm.return_name,
                            callback: function($$v) {
                              _vm.$set(_vm.addForm, "return_name", $$v)
                            },
                            expression: "addForm.return_name"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "被派电话", prop: "return_tel" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入被派电话" },
                          model: {
                            value: _vm.addForm.return_tel,
                            callback: function($$v) {
                              _vm.$set(_vm.addForm, "return_tel", $$v)
                            },
                            expression: "addForm.return_tel"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c("el-button", { on: { click: _vm.cancelAddForm } }, [
                      _vm._v("取消")
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.submitAddForm }
                      },
                      [_vm._v("确定")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }